_ = require('lodash')

angular.module('workflow.app')

.factory 'User', ( userApi, Utils ) ->

  # A singleton
  new class User

    resolve: ->
      userApi.User.get().$promise.then (user) =>
        angular.extend(@, user)

    hasTaggingConfigs: ->
      @client_tagging_configs.length > 0

    getTaggingConfig: (type) ->
      _.find(@client_tagging_configs, (tagging_config) -> tagging_config.config.type == type)

    hasTaggingConfig: (type) ->
      @getTaggingConfig(type)?

    getSupportedExtensions: ->
      @supported_extensions

    defaultWorkflowId: ->
      @default_workflow_id

    defaultWorkflowCountryId: ->
      @default_workflow_country_id

    # `is_manager` is included as a manager override (similar to the backend).
    # standard is false, you need to explicitely pass "true" to allow all managers
    hasPermission: ( permission, allow_manager = false ) ->
      return @is_staff or (allow_manager and @is_manager) or (permission in (@permissions or []))

    projectPermissions: (project) ->
      ownProject = project.owner.id == @id

      return {
        # Permissions that do not change depending on report assignee
        addComment:                               'workflow.add_comment'                                        in @permissions
        changeCommentByCurrentUser:               'workflow.change_own_comment'                                 in @permissions
        changeCommentByUsersOtherThanCurrentUser: 'workflow.change_not_own_comment'                             in @permissions
        canAlterAdverseTerms:                     'workflow.can_alter_adverse_terms'                            in @permissions

        # Permissions that change depending on report assignee

        # 1. Completing a step
        # 2. Marking a step as not applicable
        # 3. Manual step changes
        # 4. Ignoring sources
        changeStep:                               'workflow.change_step_of_own_project'                         in @permissions and     ownProject \
                                               or 'workflow.change_step_of_not_own_project'                     in @permissions and not ownProject

        changeStepSummary:                        'workflow.change_step_summary_of_own_project'                 in @permissions and     ownProject \
                                               or 'workflow.change_step_summary_of_not_own_project'             in @permissions and not ownProject

        deleteStep:                               'workflow.delete_step_of_own_project'                         in @permissions and     ownProject \
                                               or 'workflow.delete_step_of_not_own_project'                     in @permissions and not ownProject

        createIteration:                          'workflow.create_iteration_of_own_project'                    in @permissions and     ownProject \
                                               or 'workflow.create_iteration_of_not_own_project'                in @permissions and not ownProject

        changeProjectSummary:                     'workflow.change_project_summary_of_own_project'              in @permissions and     ownProject \
                                               or 'workflow.change_project_summary_of_not_own_project'          in @permissions and not ownProject

        uploadDocument:                           'workflow.can_upload_document'                               in @permissions

        createProjectStarredDocument:             'workflow.create_project_starred_document_of_own_project'     in @permissions and     ownProject \
                                               or 'workflow.create_project_starred_document_of_not_own_project' in @permissions and not ownProject

        changeProjectStarredDocument:             'workflow.change_project_starred_document_of_own_project'     in @permissions and     ownProject \
                                               or 'workflow.change_project_starred_document_of_not_own_project' in @permissions and not ownProject

        changeReportStatus:                       'workflow.change_project_state_of_own_project'                in @permissions and     ownProject \
                                               or 'workflow.change_project_state_of_not_own_project'            in @permissions and not ownProject
      }
